























import { GeekHistoryLevel } from '@/models/geek-profile';
import Vue from 'vue';

export default Vue.extend({
  name: 'HistoryTableLevelUp',
  props: {
    data: Object as () => GeekHistoryLevel,
  },
  computed: {
    levelUpDescription(): string {
      return this.$t(
        `geek-profile.history-tab.actions.level.description`,
        {
          level: this.data.level.newLevel,
        },
      ) as string;
    },
  },
});
